import React from 'react';

const ENCLOSED_LIFT = /gondola|cable_car|tram|funitel/;

// A chair hanging from the cable, or a cabin for enclosed lifts
const LiftIcon = ({ liftType, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="2" y1="7" x2="22" y2="3" />
    <line x1="12" y1="5" x2="12" y2="10" />
    {ENCLOSED_LIFT.test(liftType ?? '') ? (
      <rect x="6" y="10" width="12" height="11" rx="3" fill="currentColor" />
    ) : (
      <path d="M7 10v6a2 2 0 0 0 2 2h9M12 10h-5M18 18v3" />
    )}
  </svg>
);

export default LiftIcon;
